<div class="w-full bg-white shadow-sm relative" #gridRoot>
  <!-- Loading screen -->
  <div *ngIf="isExporting || (isLoading && showBlockingLoader)"
    class="fixed top-0 left-0 right-0 bottom-0 w-full h-screen z-50 overflow-hidden bg-white opacity-75 flex flex-col items-center justify-center z-50">
    <div class="animate-spin rounded-full h-32 w-32 border-t-2 border-b-2 border-indigo-500 !important"></div>
    <p *ngIf="isExporting" class="mt-4 text-gray-700">Exporting data...</p>
  </div>

  <!--  Error Card -->
  <div *ngIf="showErrorCard" class="fixed inset-0 flex items-center justify-center bg-gray-900 bg-opacity-50 z-50"
    (click)="closeErrorCard()">
    <div class="bg-white rounded-lg shadow-xl p-6 max-w-sm w-full relative" (click)="$event.stopPropagation()">
      <button (click)="closeErrorCard()" class="absolute top-2 right-2 text-gray-400 hover:text-gray-600">
        <svg class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>
      <div class="text-center">
        <svg class="mx-auto h-12 w-12 text-red-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
            d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
        <h3 class="mt-2 text-lg font-medium text-gray-900">{{ errorTitle }}</h3>
        <p class="mt-1 text-sm text-gray-500">{{ errorMessage }}</p>
      </div>
      <div class="mt-5">
        <button (click)="onReloadAfterError()"
          class="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-indigo-600 text-base font-medium text-white hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:text-sm">
          Try Again
        </button>
      </div>
    </div>
  </div>

  <!-- Reset Installation Confirmation Dialog -->
  <div *ngIf="showResetConfirmation"
    class="fixed inset-0 flex items-center justify-center bg-gray-900 bg-opacity-50 z-50"
    (click)="cancelResetInstallation()">
    <div class="bg-white rounded-lg shadow-xl p-6 max-w-md w-full relative" (click)="$event.stopPropagation()">
      <div class="text-center">
        <svg class="mx-auto h-12 w-12 text-red-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
            d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L4.082 16.5c-.77.833.192 2.5 1.732 2.5z" />
        </svg>
        <h3 class="mt-2 text-lg font-medium text-gray-900">Reset Installation</h3>
        <p class="mt-2 text-sm text-gray-500">
          Are you sure you want to reset the installation for <strong>{{ selectedPractice?.name }}</strong>?
          This action cannot be undone and will remove all installation data.
        </p>
      </div>
      <div class="mt-6 flex gap-3">
        <button (click)="cancelResetInstallation()"
          class="flex-1 inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:text-sm">
          Cancel
        </button>
        <button (click)="resetInstallation()"
          class="flex-1 inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-red-600 text-base font-medium text-white hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 sm:text-sm">
          Reset Installation
        </button>
      </div>
    </div>
  </div>

  <!-- Empty Data Handling -->
  <div *ngIf="dataSource.data.length === 0 && !isLoading" class="absolute flex items-center justify-center bg-white"
    style="top: 120px; left: 0; right: 0; bottom: 0;">
    <div class="text-center">
      <svg class="mx-auto h-12 w-12 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
          d="M20 13V6a2 2 0 00-2-2H6a2 2 0 00-2 2v7m16 0v5a2 2 0 01-2 2H6a2 2 0 01-2-2v-5m16 0h-2.586a1 1 0 00-.707.293l-2.414 2.414a1 1 0 01-.707.293h-3.172a1 1 0 01-.707-.293l-2.414-2.414A1 1 0 006.586 13H4" />
      </svg>
      <h3 class="mt-2 text-lg font-medium text-gray-900">
        No data available
      </h3>
      <p class="mt-1 text-sm text-gray-500">{{ emptyDataMessage }}</p>
    </div>
  </div>

  <!-- Grid content -->
  <div class="w-full !important">
    <div class="w-full !important" [ngClass]="{ 'opacity-50': isLoading }">
      <section class="border-collapse pb-3 mt-2 h-full bg-white shadow-sm !important">
        <div class="flex w-full items-center justify-between gap-2 mb-1 px-4 py-2 bg-white border-collapse !important">
          <div class="flex items-center gap-2 flex-shrink-0">
            <!-- Search -->
            <div class="relative">
              <div class="absolute inset-y-0 left-0 flex items-center pl-2 pointer-events-none">
                <svg class="w-3 h-3 text-gray-500" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20">
                  <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z" />
                </svg>
              </div>
              <input matInput id="table-search-users"
                class="block py-1 pl-8 pr-2 text-sm text-gray-900 border border-gray-300 rounded w-48 bg-gray-50 focus:ring-indigo-500 focus:border-indigo-500"
                placeholder="Search" [(ngModel)]="searchQuery" (input)="applyFilter($any($event.target).value)" />
            </div>

            <!-- View Options Dropdown (Practice Pages) -->
            <div class="relative w-full sm:w-auto" data-grid-dropdown-region
              *ngIf="gridConfig.displayHideAuditColumnsToggle && isPracticePage()" (click)="$event.stopPropagation()">
              <button type="button"
                class="inline-flex justify-between items-center w-full sm:w-48 px-3 py-1.5 bg-white border border-gray-300 regular-font text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                [ngClass]="{ 'ring-2 ring-indigo-500 bg-indigo-50': selectedViewOption !== 'all' }"
                (click)="toggleViewOptionsDropdown($event)">
                <span class="truncate">{{ getViewOptionLabel() }}</span>
                <svg class="-mr-1 ml-2 h-4 w-4 flex-shrink-0" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"
                  fill="currentColor">
                  <path fill-rule="evenodd"
                    d="M5.23 7.21a.75.75 0 011.06.02L10 11.168l3.71-3.938a.75.75 0 111.08 1.04l-4.25 4.5a.75.75 0 01-1.08 0l-4.25-4.5a.75.75 0 01.02-1.06z"
                    clip-rule="evenodd" />
                </svg>
              </button>
              <div class="absolute left-0 mt-2 w-56 bg-white border border-gray-200 rounded-sm shadow-lg z-10 zindex-11"
                [ngClass]="{ hidden: !isViewOptionsOpen }">
                <div class="py-1">
                  <div class="px-4 py-2 hover:bg-gray-100" *ngFor="let opt of [
                    { value: 'all', label: 'All Practices' },
                    { value: 'active', label: 'Active Practices' },
                    { value: 'disabled', label: 'Disabled Practices' },
                    { value: 'installed-practices', label: 'Installed Practices' },
                    { value: 'pending-installation', label: 'Pending Installation' },
                    { value: 'go-live', label: 'Live Practices' }
                  ]">
                    <label class="inline-flex items-center cursor-pointer">
                      <input type="radio" name="practiceViewOption" [value]="opt.value"
                        [checked]="selectedViewOption === opt.value" (change)="selectViewOption(opt.value)"
                        class="form-radio h-4 w-4 text-indigo-600" />
                      <span class="ml-2 regular-font text-gray-700">{{ opt.label }}</span>
                    </label>
                  </div>
                </div>
              </div>
            </div>

            <!-- View Options Dropdown (PMS Configuration Pages) -->
            <div class="relative w-full sm:w-auto" data-grid-dropdown-region
              *ngIf="gridConfig.displayHideAuditColumnsToggle && isConfigurationPage()"
              (click)="$event.stopPropagation()">
              <button type="button"
                class="inline-flex justify-between items-center w-full sm:w-40 px-3 py-1.5 bg-white border border-gray-300 regular-font text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                [ngClass]="{ 'ring-2 ring-indigo-500 bg-indigo-50': selectedConfigViewOption !== 'all' }"
                (click)="toggleViewOptionsDropdown($event)">
                <span class="truncate">{{ getConfigViewOptionLabel() }}</span>
                <svg class="-mr-1 ml-2 h-4 w-4 flex-shrink-0" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"
                  fill="currentColor">
                  <path fill-rule="evenodd"
                    d="M5.23 7.21a.75.75 0 011.06.02L10 11.168l3.71-3.938a.75.75 0 111.08 1.04l-4.25 4.5a.75.75 0 01-1.08 0l-4.25-4.5a.75.75 0 01.02-1.06z"
                    clip-rule="evenodd" />
                </svg>
              </button>
              <div class="absolute left-0 mt-2 w-56 bg-white border border-gray-200 rounded-sm shadow-lg z-10"
                [ngClass]="{ hidden: !isViewOptionsOpen }">
                <div class="py-1">
                  <div class="px-4 py-2 hover:bg-gray-100" *ngFor="let opt of [
                    { value: 'all', label: 'All ' + getPageName() },
                    { value: 'active', label: 'Active ' + getPageName() },
                    { value: 'disabled', label: 'Disabled ' + getPageName() }
                  ]">
                    <label class="inline-flex items-center cursor-pointer">
                      <input type="radio" name="configViewOption" [value]="opt.value"
                        [checked]="selectedConfigViewOption === opt.value"
                        (change)="selectConfigViewOption(opt.value)"
                        class="form-radio h-4 w-4 text-indigo-600" />
                      <span class="ml-2 regular-font text-gray-700">{{ opt.label }}</span>
                    </label>
                  </div>
                </div>
              </div>
            </div>

            <!-- Dropdown Filters -->
            <div class="flex items-center gap-2" *ngIf="(gridConfig.filters && gridConfig.filters.length !== 0)">
              <div *ngFor="let filterConfig of gridConfig?.filters"
                class="relative inline-block text-left select-filter-menu" (click)="$event.stopPropagation()">

                <div class="audit-report-dropdown" data-grid-dropdown-region appClickOutsideDirective
                  (appClickOutside)="closeAllDropdowns()">

                  <!-- Dropdown button -->
                  <button type="button"
                    class="inline-flex justify-between w-36 border border-gray-300 px-2 py-1 bg-white text-sm text-gray-700 hover:bg-gray-50 focus:outline-none rounded"
                    (click)="toggleFilterDropdown(filterConfig.jsonKey, $event)">
                    <span *ngIf="!isFilterApplied(filterConfig)" class="truncate">{{ filterConfig.label }}</span>
                    <span *ngIf="isFilterApplied(filterConfig)" class="truncate">
                      <span *ngIf="filterConfig.type === 'single'">
                        <span class="inline-block w-2 h-2 mr-1 bg-indigo-500 rounded-full"></span>
                        {{ getSelectedOptionName(filterConfig) }}
                      </span>
                      <span *ngIf="filterConfig.type === 'multi'">
                        <span class="truncate">{{ getSelectedOptionNames(filterConfig) }}</span>
                      </span>
                      <span *ngIf="filterConfig.type === 'date' && !showDateFilterDropdown">
                        <span class="inline-block w-2 h-2 mr-1 bg-indigo-500 rounded-full"></span>
                        {{ getDateFilterLabel(filterConfig) }}
                      </span>
                      <span *ngIf="filterConfig.type === 'date' && showDateFilterDropdown">
                        <span class="inline-block w-4 h-4 mr-2 border border-gray-300 rounded-full"
                          [ngClass]="{'bg-indigo-500 border-indigo-500':filters[filterConfig.jsonKey]}"></span>
                        {{ getDateFilterLabel(filterConfig) }}
                      </span>
                      <span class="ml-1 bg-gray-200 text-gray-700 rounded px-1 text-xs">{{
                        getAppliedFilterCount(filterConfig) }}</span>
                    </span>
                    <svg class="-mr-1 ml-2 h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"
                      fill="currentColor" aria-hidden="true">
                      <path fill-rule="evenodd"
                        d="M10 12a1 1 0 01-.707-.293l-4-4a1 1 0 111.414-1.414L10 9.586l3.293-3.293a1 1 0 011.414 1.414l-4 4A1 1 0 0110 12z"
                        clip-rule="evenodd" />
                    </svg>
                  </button>

                  <!-- Dropdown Content -->
                  <div
                    class="origin-top-right absolute max-w-[450px] w-fit whitespace-nowrap left-0 z-50 top-5 mt-2 w-180 shadow-lg bg-white ring-1 ring-black ring-opacity-5"
                    [ngClass]="{
                    hidden: !isFilterDropdownOpen[filterConfig.jsonKey],
                    'max-h-96 overflow-auto':
                      filterConfig.type === 'date' &&
                      filters[filterConfig.jsonKey] === 'custom'
                  }">
                    <div class="py-1 max-h-[250px] w-full overflow-auto" role="menu" aria-orientation="vertical"
                      aria-labelledby="options-menu" [ngClass]="{
                      'filter-dropdown-menu': filterConfig.type === 'multi',
                      'select-date-menu': filterConfig.type === 'date'
                    }">
                      <ng-container *ngIf="filterConfig.type === 'multi'">
                        <div class="px-4 py-2 w-fit" *ngFor="let option of filterConfig.options?.data">
                          <label class="inline-flex items-center w-fit">
                            <input type="checkbox"
                              class="form-checkbox h-4 w-4 text-indigo-600 transition duration-150 ease-in-out"
                              [checked]="
                              isFilterOptionSelected(filterConfig, option)
                            " (change)="
                              onFilterOptionChange(
                                filterConfig,
                                option,
                                $event.target['checked']
                              )
                            " />
                            <span class="ml-2 regular-font text-gray-700 w-fit">{{ option.name }}</span>
                          </label>
                        </div>
                      </ng-container>
                      <ng-container *ngIf="filterConfig.type === 'single'">
                        <a *ngFor="let option of filterConfig.options?.data"
                          (click)="onFilterOptionClick(filterConfig, option)"
                          class="px-4 py-2 regular-font text-gray-700 hover:bg-gray-100 hover:text-gray-900 flex items-center"
                          role="menuitem">
                          <span class="inline-block w-4 h-4 mr-2 border border-gray-300 rounded-full regular-font"
                            [ngClass]="{
                            'bg-indigo-500 border-indigo-500':
                              filters[filterConfig.jsonKey] === option.id
                          }"></span>
                          {{ option.name }}
                        </a>
                      </ng-container>
                      <ng-container *ngIf="filterConfig.type === 'date' && !showDateFilterDropdown">
                        <div class="py-1 select-date-menu" role="menu" aria-orientation="vertical"
                          aria-labelledby="options-menu">
                          <a *ngFor="
                            let option of getDateFilterOptions(filterConfig)
                          " (click)="
                            onDateFilterOptionChange(
                              filterConfig,
                              option.value
                            )
                          " class="flex px-4 py-2 w-48 overflow-hidden regular-font text-gray-700 hover:bg-gray-100 hover:text-gray-900 items-center"
                            role="menuitem">
                            <span class="inline-block w-4 h-4 mr-2 border border-gray-300 rounded-full" [ngClass]="{
                              'bg-indigo-500 border-indigo-500':
                                this.isSelected === option.value
                            }"></span>
                            {{ option.label }}
                          </a>
                          <div *ngIf="filters[filterConfig.jsonKey] === 'custom'" class="px-4 py-2">
                            <div class="flex items-center justify-between">
                              <span class="mr-2 regular-font">From: </span>
                              <input type="date" class="form-input regular-font shadow-lg border-b-2 pl-1 pr-1"
                                [(ngModel)]="customDateRange.from" />
                            </div>
                            <div class="flex items-center mt-2 justify-between">
                              <span class="mr-2 regular-font">To: </span>
                              <input type="date" class="form-input regular-font shadow-lg border-b-2 pl-1 pr-1"
                                [(ngModel)]="customDateRange.to" />
                            </div>
                          </div>
                        </div>
                      </ng-container>
                      <ng-container *ngIf="filterConfig.type === 'date' && showDateFilterDropdown">
                        <div class="py-1 select-date-menu" role="menu" aria-orientation="vertical"
                          aria-labelledby="options-menu">

                          <!-- Custom Date Inputs Always Visible -->
                          <div class="px-4 py-2">
                            <div class="flex items-center justify-between">
                              <span class="mr-2 regular-font">From:
                              </span>
                              <input type="date" class="form-input regular-font shadow-lg border-b-2 pl-1 pr-1"
                                [(ngModel)]="customDateRange.from" [max]="customDateRange.to" [min]="minFromDate"
                                (change)="onCustomDateChange(filterConfig)" [disabled]="isDateInputDisabled" />
                            </div>
                            <div class="flex items-center mt-2 justify-between">
                              <span class="mr-2 regular-font">To: </span>
                              <input type="date" class="form-input regular-font shadow-lg border-b-2 pl-1 pr-1"
                                [(ngModel)]="customDateRange.to" [min]="customDateRange.from" [max]="maxToDate"
                                (change)="onCustomDateChange(filterConfig)" [disabled]="isDateInputDisabled" />
                            </div>
                          </div>
                        </div>
                      </ng-container>
                    </div>
                    <div *ngIf="hasFilterOptionsSelected(filterConfig)" class="flex justify-end px-4 py-2 space-x-2">
                      <button (click)="applyFilters(filterConfig)"
                        class="px-3 py-1 regular-font text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                        Apply
                      </button>
                      <button (click)="cancelFilters(filterConfig)"
                        class="px-3 py-1 regular-font text-gray-700 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                        Cancel
                      </button>
                    </div>
                  </div>

                </div>
              </div>
            </div>

            <!-- Create Button -->
            <button *ngIf="gridConfig.displayAdd" (click)="onAddClick()"
              [ngClass]="{ 'hide-element': userRole === 'USER' }"
              class="flex items-center text-white bg-indigo-500 hover:bg-indigo-400 focus:ring-2 focus:ring-indigo-500 text-sm px-2 py-1 rounded">
              <span class="mr-1">Create</span>
              <svg class="w-3 h-3" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20">
                <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
              </svg>
            </button>

            <div class="flex items-center w-full sm:w-auto">
              <button
                aria-label="Reset Filter"
                class="inline-flex items-center ring-offset-1 text-white bg-indigo-500 ring-gray-300 focus:outline-none hover:bg-indigo-400 focus:ring-2 focus:ring-indigo-500 regular-font px-3 py-1.5 w-full sm:w-auto justify-center sm:justify-start !important"
                (click)="resetFilter()">
                <span class="mr-1 !important">Reset Filter</span>
                <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" width="18" height="18" viewBox="0 0 32 32"
                  id="icon" stroke="4">
                  <defs>
                    <style>
                      .cls-1 {
                        fill: none;
                      }
                    </style>
                  </defs>
                  <path
                    d="M22.5,9A7.4522,7.4522,0,0,0,16,12.792V8H14v8h8V14H17.6167A5.4941,5.4941,0,1,1,22.5,22H22v2h.5a7.5,7.5,0,0,0,0-15Z" />
                  <path
                    d="M26,6H4V9.171l7.4142,7.4143L12,17.171V26h4V24h2v2a2,2,0,0,1-2,2H12a2,2,0,0,1-2-2V18L2.5858,10.5853A2,2,0,0,1,2,9.171V6A2,2,0,0,1,4,4H26Z" />
                  <rect id="_Transparent_Rectangle_" data-name="&lt;Transparent Rectangle&gt;" class="cls-1" width="32"
                    height="32" />
                </svg>
              </button>
            </div>
          </div>

          <!-- Third Row: Headers -->
          <div *ngIf="gridConfig.headers && gridConfig.headers.length !== 0" class="flex flex-wrap gap-2">
            <div *ngFor="let header of gridConfig.headers"
              class="flex ring-inset bg-gray-50 py-1.5 regular-font rounded-sm px-2 ring-1 ring-gray-300">
              <div class="truncate">
                <span class="regular-font">{{ header.label }} : </span>
                {{ header.value }}
              </div>
            </div>
          </div>

          <!-- Fourth Row: View Options and Export Controls -->
          <div class="flex flex-col sm:flex-row gap-3 items-start sm:items-center justify-between">
            <div class="flex flex-col sm:flex-row gap-3 items-start sm:items-center w-full sm:w-auto">
              <!-- View Options Dropdown (User Management Pages) -->
              <div class="relative w-full sm:w-auto" data-grid-dropdown-region
                *ngIf="gridConfig.displayHideAuditColumnsToggle && isUserManagementPage()"
                (click)="$event.stopPropagation()">
                <button type="button"
                  class="inline-flex justify-between items-center w-full sm:w-40 px-3 py-1.5 bg-white border border-gray-300 regular-font text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                  [ngClass]="{ 'ring-2 ring-indigo-500 bg-indigo-50': isFromActiveUsers }"
                  (click)="toggleViewOptionsDropdown($event)">
                  <span>View Options</span>
                  <span *ngIf="isFromActiveUsers" class="ml-1 w-2 h-2 bg-indigo-500 rounded-full"></span>
                  <svg class="-mr-1 ml-2 h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"
                    fill="currentColor">
                    <path fill-rule="evenodd"
                      d="M5.23 7.21a.75.75 0 011.06.02L10 11.168l3.71-3.938a.75.75 0 111.08 1.04l-4.25 4.5a.75.75 0 01-1.08 0l-4.25-4.5a.75.75 0 01.02-1.06z"
                      clip-rule="evenodd" />
                  </svg>
                </button>
                <div class="absolute right-0 mt-2 w-56 bg-white border border-gray-200 rounded-sm shadow-lg z-10"
                  [ngClass]="{ hidden: !isViewOptionsOpen }">
                  <div class="py-1">
                    <div class="px-4 py-2 hover:bg-gray-100">
                      <label class="inline-flex items-center cursor-pointer">
                        <input type="checkbox" [checked]="filters['isActive'] === false"
                          (change)="toggleShowInactiveUsers()" class="form-checkbox h-4 w-4 text-indigo-600" />
                        <span class="ml-2 regular-font text-gray-700">Show Inactive Users</span>
                      </label>
                    </div>
                  </div>
                </div>
              </div>

            </div>

            <!-- Column Selector and Export -->
            <div class="flex flex-col sm:flex-row gap-2 w-full sm:w-auto relative" data-grid-dropdown-region
              (click)="$event.stopPropagation()">
              <button type="button"
                class="inline-flex items-center px-3 py-1.5 bg-white border border-gray-300 regular-font text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-indigo-500 w-full sm:w-auto justify-center sm:justify-start"
                (click)="toggleColumnSelector($event)">
                <svg class="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16">
                  </path>
                </svg>
                <span>Select Columns</span>
                <svg class="-mr-1 ml-2 h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"
                  fill="currentColor">
                  <path fill-rule="evenodd"
                    d="M5.23 7.21a.75.75 0 011.06.02L10 11.168l3.71-3.938a.75.75 0 111.08 1.04l-4.25 4.5a.75.75 0 01-1.08 0l-4.25-4.5a.75.75 0 01.02-1.06z"
                    clip-rule="evenodd" />
                </svg>
              </button>

              <!-- Extra action buttons (e.g. Smart Schedule) injected by parent -->
              <div class="flex flex-col sm:flex-row gap-2 w-full sm:w-auto">
                <ng-container *ngFor="let action of extraActions">
                  <button *ngIf="isExtraActionVisible(action)" type="button"
                    [class]="action.cssClass || 'inline-flex items-center gap-1 px-3 py-1.5 bg-indigo-500 hover:bg-indigo-400 text-white regular-font focus:outline-none focus:ring-2 focus:ring-indigo-500'"
                    (click)="action.action()">
                    <span>{{ action.label }}</span>
                  </button>
                </ng-container>
              </div>

              <div class="relative" data-grid-dropdown-region (click)="$event.stopPropagation()">
                <button
                  class="inline-flex items-center ring-offset-1 text-white bg-indigo-500 ring-gray-300 focus:outline-none hover:bg-indigo-400 focus:ring-2 focus:ring-indigo-500 regular-font px-3 py-1.5 w-full sm:w-auto justify-center sm:justify-start !important"
                  (click)="toggleDropdown($event)">
                  <span class="mr-1 !important">Export</span>
                  <svg class="w-4 h-4 !important" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none"
                    viewBox="0 0 20 20">
                    <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
                  </svg>
                </button>

                <div
                  class="absolute right-0 mt-2 w-48 bg-white border border-gray-200 rounded-sm shadow-lg z-10 !important"
                  [ngClass]="{ hidden: !isDropdownOpen }" (click)="$event.stopPropagation()">
                  <a class="block px-4 py-2 regular-font text-gray-700 hover:bg-gray-100 cursor-pointer !important"
                    (click)="exportData()">
                    Export Current Data To Excel
                  </a>
                  <div class="border-t border-gray-200"></div>
                  <a class="block px-4 py-2 regular-font text-gray-700 hover:bg-gray-100 cursor-pointer !important"
                    (click)="exportAllData()">
                    Export All Data To Excel
                  </a>
                  <div class="border-t border-gray-200"></div>
                  <a class="block px-4 py-2 regular-font text-gray-700 hover:bg-gray-100 cursor-pointer !important"
                    (click)="exportDataToPDF('Report', 'Current')">
                    Export Current Data To PDF
                  </a>
                  <div class="border-t border-gray-200"></div>
                  <a class="block px-4 py-2 regular-font text-gray-700 hover:bg-gray-100 cursor-pointer !important"
                    (click)="exportDataToPDF('Report', 'All')">
                    Export All Data To PDF
                  </a>
                </div>
              </div>

              <div
                class="column-selector-dropdown absolute right-0 sm:right-4 top-8 mt-2 w-48 bg-white border border-gray-200 rounded-sm shadow-lg z-10"
                [ngClass]="{ hidden: !isColumnSelectorOpen }" (click)="$event.stopPropagation()">
                <div class="py-1 max-h-64 overflow-auto">
                  <div class="px-4 py-2 hover:bg-gray-100" *ngFor="let column of gridConfig?.columns">
                    <label class="inline-flex items-center cursor-pointer">
                      <input type="checkbox" class="form-checkbox h-4 w-4 text-indigo-600"
                        [checked]="isColumnVisible(column.jsonKey)" (change)="toggleColumnVisibility(column.jsonKey)" />
                      <span class="ml-2 regular-font text-gray-700">{{ column.label }}</span>
                    </label>
                  </div>
                </div>
                <div class="border-t border-gray-200 px-2 py-1">
                  <button
                    class="w-full inline-flex justify-center items-center px-3 py-1.5 text-white bg-indigo-500 hover:bg-indigo-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 regular-font disabled:opacity-50 disabled:cursor-not-allowed"
                    (click)="onSavePreferences($event)" [disabled]="isSavingPreferences">
                    <div class="animate-spin rounded-full h-4 w-4 border-t-2 border-b-2 border-white mr-2"
                      *ngIf="isSavingPreferences"></div>
                    <span>{{ isSavingPreferences ? 'Saving...' : 'Save Preferences' }}</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- User Management Note -->
        <div *ngIf="isUserManagementPage()" class="px-4 py-2 bg-blue-50 border-l-4 border-blue-400 mb-2">
          <div class="flex">
            <div class="flex-shrink-0">
              <svg class="h-5 w-5 text-blue-400" viewBox="0 0 20 20" fill="currentColor">
                <path fill-rule="evenodd"
                  d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z"
                  clip-rule="evenodd" />
              </svg>
            </div>
            <div class="ml-3">
              <p class="text-sm text-blue-700 regular-font">
                <strong>Note:</strong> For security reasons, the admin user and your account details are not displayed.
              </p>
            </div>
          </div>
        </div>

        <ng-container #tableSection>
          <section class="overflow-auto h-[calc(100vh-210px)] !important" id="table-section">
            <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z8 !important">
              <!-- Action Column -->
              <ng-container matColumnDef="action" *ngIf="gridConfig?.editable || gridConfig?.deletable" sticky>
                <th mat-header-cell *matHeaderCellDef [ngClass]="{ 'hide-element': userRole === 'USER' }"
                  class="sticky top-0 regular-font text-gray-700 uppercase !bg-violet-100 whitespace-nowrap !z-10 !important !w-9">
                  {{ gridConfig?.actionColumnLabel || 'Edit' }}
                </th>
                <td mat-cell *matCellDef="let element" class="py-2 px-4 whitespace-nowrap regular-font !important !w-9"
                  [ngClass]="{ 'hide-element': userRole === 'USER' }">
                  <div class="flex gap-2 items-center !important">
                    <mat-icon *ngIf="gridConfig?.editable" (click)="onEditClick(element)"
                      class="text-[20px] text-center cursor-pointer text-blue-500 hover:text-blue-600 !important">edit</mat-icon>
                    <i *ngIf="gridConfig?.editable2" (click)="!disableEditable2(element) && onEdit2Click(element)"
                      [class.disabled]="disableEditable2(element)"
                      class="fas fa-database text-[20px] text-center cursor-pointer text-blue-500 hover:text-blue-600 !important">
                    </i>
                    <mat-icon *ngIf="gridConfig?.deletable" (click)="onDelete(element)"
                      class="text-[20px] text-center cursor-pointer text-red-500 hover:text-red-600 !important">delete</mat-icon>

                    <!-- Practice Actions Menu -->
                    <div *ngIf="isDashboardSummaryGrid()" class="relative" data-grid-dropdown-region
                      (click)="$event.stopPropagation()">
                      <button (click)="togglePracticeMenu(element.id, $event)"
                        class="text-gray-500 hover:text-gray-700 cursor-pointer p-1">
                        <svg class="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                          <path
                            d="M10 6a2 2 0 110-4 2 2 0 010 4zM10 12a2 2 0 110-4 2 2 0 010 4zM10 18a2 2 0 110-4 2 2 0 010 4z" />
                        </svg>
                      </button>
                      <div *ngIf="practiceMenuOpen[element.id]"
                        class="absolute right-0 mt-1 w-48 bg-white border border-gray-200 rounded-sm shadow-lg z-50"
                        (click)="$event.stopPropagation()">
                        <div class="py-1">
                          <a (click)="startOnDemandLoad(element)"
                            class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 cursor-pointer">
                            Start On-Demand Load
                          </a>
                          <a (click)="restartAgentService(element)"
                            class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 cursor-pointer">
                            Restart Agent Service
                          </a>
                          <a (click)="confirmResetInstallation(element)"
                            class="block px-4 py-2 text-sm text-red-600 hover:bg-gray-100 cursor-pointer">
                            Reset Installation
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </td>
              </ng-container>

              <!-- Other Columns Definition -->
              <ng-container matColumnDef="{{ column.jsonKey }}" *ngFor="let column of gridConfig?.columns"
                [sticky]="column.dataType === 'toggle' || column.isSticky === true">
                <ng-container *ngIf="column.isSortable !== false;else notSortable">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header
                    class="sticky top-0 regular-font text-gray-700 !bg-violet-100 whitespace-nowrap !important"
                    [ngClass]="{
                      '!z-10': column.dataType === 'toggle',
                      'uppercase': !column.noUppercase
                    }">
                    <span [ngClass]="{
                        'justify-center w-full flex h-full':
                          column.dataType == 'date' ||
                          column.dataType == 'number' ||
                          column.dataType == 'custom-link'
                      }">
                      {{ column.label }}
                    </span>
                  </th>
                </ng-container>
                <ng-template #notSortable>
                  <th mat-header-cell *matHeaderCellDef
                    class="sticky top-0 regular-font text-gray-700 !bg-violet-100 whitespace-nowrap !important !w-fit"
                    [ngClass]="{
                      '!z-10': column.dataType === 'toggle',
                      'uppercase': !column.noUppercase
                    }">
                    <span [ngClass]="{
                        'justify-center w-full flex h-full':
                          column.dataType == 'date' ||
                          column.dataType == 'number' ||
                          column.dataType == 'custom-link'
                      }">
                      {{ column.label }}
                    </span>
                  </th>
                </ng-template>

                <td mat-cell *matCellDef="let element" class="py-2 px-4 whitespace-nowrap regular-font !important w-fit"
                  [ngClass]="{ 'clickable-row': isRowClickable }" (click)="isRowClickable && rowClick(element, $event)"
                  [attr.title]="isRowClickable ? 'Click to view details' : null">
                  <ng-container [ngSwitch]="column.dataType">
                    <app-tailwind-toggle *ngSwitchCase="'toggle'" [toggleId]="element.id + '_' + column.jsonKey"
                      [checked]="element[column.jsonKey]" [disabled]="
                        gridConfig.isToggleDisabled ||
                        disableSuccessAcknowldgeToggle(element)
                      " (onToggleChange)="
                        onToggleChange(element, column.jsonKey, $event)
                      "></app-tailwind-toggle>
                    <span *ngSwitchCase="'date'" class="!important">{{
                      this.formatDateTime(element[column.jsonKey])
                      }}</span>
                    <span *ngSwitchCase="'dateOnly'">
                      {{ element[column.jsonKey] | date : "yyyy-MM-dd" }}
                    </span>
                    <span *ngSwitchCase="'boolean'">{{
                      element[column.jsonKey] ? "Yes" : "No"
                      }}</span>
                    <span *ngSwitchCase="'password'" class="w-full flex h-full">{{ "********" }}</span>
                    <span *ngSwitchCase="'text-wrap'">
                      <!-- Insert the html by innerhtml if it supports markdown -->
                      <p class="inline-block text-wrap  markdown" *ngIf="
                          column.width !== 'full' && column.isMarkDownSupported
                        " [innerHTML]="
                          getMakrDownText(
                            column.isMarkDownSupported,
                            element[column.jsonKey]
                          )
                        " [ngClass]="{
                          'justify-center w-full flex h-full':
                            column.dataType == 'date' ||
                            column.dataType == 'number',
                          uppercase: column.toUppercase
                        }"></p>
                      <!-- show normal text -->
                      <p class="text-wrap max-w-[60vw]" *ngIf="
                          column.width !== 'full' && !column.isMarkDownSupported
                        " [ngClass]="{
                          'justify-center w-full flex h-full':
                            column.dataType == 'date' ||
                            column.dataType == 'number',
                          uppercase: column.toUppercase
                        }">
                        {{ element[column.jsonKey] }}
                      </p>
                    </span>
                    <span *ngSwitchCase="'custom-link'" class="flex justify-center">
                      <button *ngIf="element[column.jsonKey]"
                        (click)="$event.stopPropagation(); openLink(element[column.jsonKey])"
                        class="inline-flex items-center justify-center p-1 rounded text-gray-600 hover:text-blue-600 hover:bg-gray-100 transition-colors">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                          stroke="currentColor" class="w-5 h-5">
                          <path stroke-linecap="round" stroke-linejoin="round"
                            d="M3 16.5v2.25A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75V16.5M12 12.75l-4.5-4.5m4.5 4.5l4.5-4.5M12 3v9.75" />
                        </svg>
                      </button>
                    </span>
                    <span *ngSwitchDefault>
                      <span *ngSwitchDefault>
                        <span class="inline-block max-w-[15vw] whitespace-nowrap overflow-hidden overflow-ellipsis"
                          title="{{ element[column.jsonKey] }}" *ngIf="column.width !== 'full'" [ngClass]="{
                            'justify-center w-full flex h-full':
                              column.dataType == 'number',
                            uppercase: column.toUppercase
                          }">
                          {{
                          column.dataType === "number"
                          ? formatNumber(element[column.jsonKey])
                          : element[column.jsonKey]
                          }}
                        </span>
                        <span *ngIf="column.width === 'full'" class="inline-block whitespace-nowrap"
                          [ngClass]="{ uppercase: column.toUppercase }">
                          {{
                          column.dataType === "number"
                          ? formatNumber(element[column.jsonKey])
                          : element[column.jsonKey]
                          }}
                        </span>
                      </span>
                    </span>
                  </ng-container>
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="getGridColumnNames()" class="bg-gray-50 z-20 !important"></tr>
              <tr mat-row *matRowDef="let row; columns: getGridColumnNames()" class="z-10 hover:bg-slate-100 !important"
                [ngClass]="[
                    rowColorClass(row),
                    isErrorLog(row) ? '!bg-toastErrorBg !text-toastErrorColor' : '',
                    getPracticeRowHighlightClass(row)
                  ]">
              </tr>
            </table>
          </section>
        </ng-container>
      </section>
    </div>

    <!-- Paginator -->
    <div class="px-5 py-2 outer overflow-hidden !important flex justify-between items-center"
      [ngClass]="{ hidden: isLoading || totalItems === 0 }" id="paginator">
      <!-- Legend -->
      <div class="flex items-center gap-2" *ngIf="isPracticePage()">
        <div class="w-6 h-4 border-l-4 border-red-500" style="background-color: #FFF9C4;"></div>
        <span class="text-sm text-gray-600 regular-font">SERVER RUNNING LOW ON MEMORY OR DISK SPACE ({{ lowResourceCount
          }})</span>
      </div>
      <div *ngIf="!isPracticePage()"></div>

      <mat-paginator aria-label="Select page" class="custom-paginator regular-font !important"
        style="font-size: 12px !important" (page)="addAllOption()" (click)="addAllOption()" [length]="totalItems"
        [pageSize]="pageSize" [pageSizeOptions]="getPageSize()" showFirstLastButtons></mat-paginator>
    </div>
  </div>
</div>